import moment from 'moment';
import instance from '../interceptor';
import { IResultContestTargetDAO } from '../../Modules/ContestTarget/DAO/contestTarget.dao';

export const getContestTargetAPI = async (): Promise<
  IResultContestTargetDAO[]
> => {
  const { data } = await instance.get(`/contest`);
  return data;
};

export const deleteContestTargetAPI = async (id: string) => {
  return await instance.delete(`/contest/${id}`);
};

export const getContestTargetDetailAPI = async (
  params: any
): Promise<IResultContestTargetDAO> => {
  const { id } = params.queryKey[1];
  const { data } = await instance.get(`/contest/${id}`);
  return data;
};

export const mutateContestTargetAPI = async (params: any) => {
  const {
    chanel,
    contestLevel,
    contestType,
    dateContest,
    group,
    id,
    monitoringPeriode,
    numberOfTarget,
  } = params;

  const targets: object[] = [];

  for (let index = 0; index < numberOfTarget; index++) {
    const dataDetailTarget = {
      rewardId: params[`rewardId${index}`] ? params[`rewardId${index}`] : 0,
      name: params[`targetName${index}`],
      fyp: params[`rewardFyp${index}`].toString(),
      nbFyp: params[`rewardNbFyp${index}`].toString(),
      persistency: params[`rewardPersistency${index}`],
      numberOfTicket: params[`rewardNumberOfTicket${index}`]
        ? params[`rewardNumberOfTicket${index}`]
        : 0,
    };
    targets.push(dataDetailTarget);
  }

  const payload: any = {
    chanel,
    contestLevel,
    contestType,
    endDate: moment(dateContest[1]).format('YYYY-MM-DD'),
    group,
    monitoringPeriode: parseInt(monitoringPeriode),
    startDate: moment(dateContest[0]).format('YYYY-MM-DD'),
    targets,
  };

  if (id) {
    return await instance.put(`/contest/${id}`, payload);
  } else {
    return await instance.post(`/contest`, payload);
  }
};
